export default "__VITE_ASSET__BxK6nlFo__"